module.exports = __webpack_public_path__ + "img/bdlogo-color.4e41a959.png";